import useDiscard from "../../../useDiscard";
import useWeakMap from "../../../utils/useWeakMap";
import { isLayer } from "../validator/useLayerIdentity";

const store = useWeakMap();

const onDiscardLayer = (layer) => {
    store.delete(layer);
}

const useQueryLinkingLayers = (layer) => {
    const layers = store.get(layer)
    return layers ? layers : null;
}

export const storeLinkingLayer = (layer, refLayer) => {
    if (layer === refLayer) return;
    if (false === isLayer(refLayer) || false === isLayer(layer)) throw 'storeLinkingLayer - Only allow Layer'
    if (!store.has(layer)) {
        store.set(layer, new Set())
        useDiscard(layer, onDiscardLayer);
    }
    store.get(layer).add(refLayer);
}

export const deleteLinkingLayer = (layer, deletedRef) => {
    if (!store.has(layer)) return;
    store.get(layer).delete(deletedRef);
}

export default useQueryLinkingLayers